import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { SlideContainer } from './container';
import { SlideContent } from './content';
import { Text } from './text';
import { Highlight } from './highlight';
import { SlideProps } from '../Recap';
import RecapSlide from '../RecapSlide';
import { asset } from '../../../utils/misc';

const DrinkImageAnimation = keyframes`
    0% {
        transform: scale(1) rotate(0deg);
    }
    50% {
        transform: scale(1.05) rotate(4deg);
    }
    100% {
        transform: scale(1) rotate(0deg);
    }
`;

const PopCornImageAnimation = keyframes`
    0% {
        transform: scale(1) rotate(0deg);
    }
    50% {
        transform: scale(1.02) rotate(-3deg);
    }
    100% {
        transform: scale(1) rotate(0deg);
    }
`;

const DrinkImage = styled.span`
    position: absolute;
    bottom: -90px;
    left: -50px;

    & > img {
      animation: ${DrinkImageAnimation} 3s linear infinite;
      width: 190px;
    }

    @media (max-aspect-ratio: 9/16) {
      bottom: -10px;
    }
`;

const PopCornImage = styled.span`
    position: absolute;
    bottom: -180px;
    right: -60px;

    & > img {
      animation: ${PopCornImageAnimation} 3.5s linear infinite;
      width: 300px;
    }
      
    @media (max-aspect-ratio: 9/16) {
      bottom: -90px;
    }
`;

export const Slide1 = ({ current = false, scale, soundEnabled = false }: SlideProps) => {
  const sizeFactor = 1.6;
  const musicUrl = asset('/dist/audio/recap-music-01.mp3');

  return (
    <RecapSlide animations={[
      ['line-1', 'images', 'yr-logo'],
      ['line-2'],
      ['line-3'],
      ['line-4'],
    ]} focus={current} soundEnabled={soundEnabled} musicUrl={musicUrl}>
      <SlideContainer>
        <SlideContent bg="#e31a37" scale={scale}>
          <div className='yr-logo'>
            <img src={asset('/dist/images/year-recap/logo.png')} style={{ width: '200px', marginBottom: '30px' }} className='anim anim-fade-in'/>
          </div>

          <Highlight className='anim anim-fade-in line-1' fontFamily="fifties-cond-med" fontSize={27 * sizeFactor + "px"} style={{
            minHeight: 'auto',
            padding: 4 * sizeFactor + 'px',
            marginBottom: 6 * sizeFactor + 'px',
          }}>
            <span className='anim anim-slide-from-top'>Este</span>
            {' '}
            <span className='anim anim-slide-from-top'>2025</span>
          </Highlight>
          <Text className='overflow-h line-2' fontFamily="fifties-cond-med" fontSize={34 * sizeFactor + "px"}>
            <span className='anim anim-slide-from-top'>El</span>
            {' '}
            <span className='anim anim-slide-from-top'>verdadero</span>
          </Text>
          <Text fontFamily='fifties-cond-med' fontSize={41 * sizeFactor + "px"} className="line-3">
            <span className="anim anim-slide-from-left" style={{transform: `translateX(-${200 * sizeFactor}px)`}}>protagonista</span>
          </Text>
          <Text fontFamily='fifties-cond-med' fontSize={52 * sizeFactor + "px"} className="overflow-h line-4">
            <span className="anim anim-slide-from-top">fuiste</span>
            {' '}
            <span className="anim anim-slide-from-top">tú</span>
          </Text>
          <div style={{ width: '10px', height: '150px'}}>
            &nbsp;
          </div>
          
          <div className='images' style={{ position: 'absolute', bottom: 0, width: '100%' }}>
            <DrinkImage className='anim anim-scale-in anim-fade-in'>
              <img src={asset('/dist/images/year-recap/drink.png')} />
            </DrinkImage>
            <PopCornImage className='anim anim-scale-in anim-fade-in'>
              <img src={asset('/dist/images/year-recap/popcorn_bucket.png')} />
            </PopCornImage>
          </div>
        </SlideContent>
      </SlideContainer>
    </RecapSlide>
  );
};